import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import FaqsList from './FaqsList'

export default function Faqs() {
	return (
		<React.Fragment>
			<Switch>
				<Route exact path="/faqs" component={FaqsList} />

				<Redirect to="/404" />
			</Switch>
		</React.Fragment>
	)
}